import validate from "/builds/henry/yuelai-engine-blog-web/node_modules/nuxt/dist/pages/runtime/validate.js";
import permalink_45compat_45global from "/builds/henry/yuelai-engine-blog-web/middleware/permalink-compat.global.ts";
import manifest_45route_45rule from "/builds/henry/yuelai-engine-blog-web/node_modules/nuxt/dist/app/middleware/route-rules.js";
export const globalMiddleware = [
  validate,
  permalink_45compat_45global,
  manifest_45route_45rule
]
export const namedMiddleware = {}